import { formatNumber } from "@/utils/format";
import { Divider, Flex, Text } from "@mantine/core";

interface DatasetInfo {
  name: string;
  format: string;
  rowCount: number;
  columnCount: number;
  isGeocoded: boolean;
}

interface DatasetInfoBarProps {
  datasetInfo: DatasetInfo;
}

export function DatasetInfoBar({ datasetInfo }: DatasetInfoBarProps) {
  return (
    <Flex
      bg="#F0F2F6"
      w="100%"
      h={40}
      justify="flex-start"
      px="sm"
      gap="lg"
      align="center"
      pr={90}
      style={{
        borderTop: "1px solid var(--mantine-color-border-1)",
      }}
    >
      {datasetInfo.name && (
        <Text fw={500} truncate size="sm" c="gray.9">
          {datasetInfo.name}
        </Text>
      )}
      <Divider orientation="vertical" color="gray.3" h={16} my="auto" />
      <Text fw={500} size="sm" c="gray.9">
        {formatNumber(datasetInfo.rowCount)} rows
      </Text>
      <Divider orientation="vertical" color="gray.3" h={16} my="auto" />
      <Text fw={500} size="sm" c="gray.9">
        {formatNumber(datasetInfo.columnCount)} columns
      </Text>
    </Flex>
  );
}
